var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8846 1.2373L13.8841 5.73393C13.8841 5.95661 13.7885 6.1706 13.6176 6.32807L7.83118 11.6782L7.91999 11.7603C8.32801 12.1376 8.98941 12.1376 9.39743 11.7603L14.6228 6.92994C14.8192 6.7488 14.9295 6.50293 14.9295 6.24692V2.20339C14.9295 1.66963 14.4619 1.2373 13.8846 1.2373Z",
    fill: "#F74F22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7947 0.270508H7.4198C7.14291 0.270508 6.87699 0.372429 6.68108 0.55357L0.986557 5.81775C0.578537 6.195 0.578537 6.80653 0.986557 7.18427L5.36141 11.2293C5.76943 11.6065 6.43083 11.6065 6.83885 11.2293L12.5334 5.96508C12.7293 5.78345 12.8395 5.53758 12.8395 5.28109V1.23659C12.8395 0.702829 12.3719 0.270508 11.7947 0.270508ZM9.96614 3.65179C9.53356 3.65179 9.18249 3.32719 9.18249 2.92723C9.18249 2.52727 9.53356 2.20267 9.96614 2.20267C10.3987 2.20267 10.7498 2.52727 10.7498 2.92723C10.7498 3.32719 10.3987 3.65179 9.96614 3.65179Z",
    fill: "#F74F22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.81c07c405f7304b62faabf9994b392de.svg";
export { ForwardRef as ReactComponent };